import { Hex } from 'viem'
import { makeReadSurvey4Contract } from './useReadSurvey4Contract'

/*
 * Fetches the getAnswers from the Survey4 contract
 * @param survey4Address The Survey4 contract address
 * @returns The answers from the Survey4 contract
 */
export function useSurvey4Answers(survey4Address: Hex) {
	const useSurvey4ReadContract = makeReadSurvey4Contract(survey4Address)

	return useSurvey4ReadContract({ functionName: 'getAnswers' })
}
